/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ProfessionalSpecialtyType {
  MAIN = 'MAIN',
  WORK_AREA = 'WORK_AREA',
}
